<template>
  <div class="contenedor py-0">
    <h4>Booker Allocation</h4>
    <div
      class="d-flex align-items-center justify-content-center w-100"
      v-if="loading"
    >
      <LoadingSpinner></LoadingSpinner>
    </div>
    <div v-else class="mx-2">
      <div class="px-3 pb-3 d-inline">
        <Tabs :tabs="tabs" @change="changeTab($event)"
          :tabSelected="tabSelected" />
      </div>

      <div v-if="orders.length > 0">
        <div class="d-flex align-items-center justify-content-between flex-wrap mb-2">
          <div class="d-flex align-items-center">
            <span class="ml-2">{{ $t("lang.label.orderby") }}:</span>
            <span class="mx-2">
              <select v-model="orderBy" @change="updateOrder" class="form-control">
                <option value="total_cold_tasks">Total cold tasks</option>
                <option value="cold_meeting_rate">Cold meeting rate</option>
                <option value="cold_meetings">Cold meetings</option>            
                <option value="days_seniority">Seniority</option>            
              </select>
            </span>
            <span class="mx-2">
              <select v-model="orderDirection" @change="updateOrder" class="form-control">
                <option value="asc">Asc</option>
                <option value="desc">Desc</option>
              </select>
            </span>
          </div>
          <div class="d-flex align-items-center mr-3" @click.stop>
            <input
              type="checkbox"
              :checked="isAllSelected"
              :disabled="getOrdersFiltered().length === 0"
              @change="toggleSelectAll"
            />
            <span class="ml-1 font-weight-bold">Select All</span>
          </div>
        </div>

        <div class="col-md-12 w-100 my-3 card p-2">
          <div class="mx-0 px-0 table-responsive">
            <div class="row">
              <Table
                ref="bookerTable"
                class="mx-2"
                :key="keyTable"
                :headers="headers"
                :cols="cols"
                :data="getOrdersFiltered()"
                :checkbox="false"
                :notselect="true"
                :showTargetsExternalControls="true"
                :model="model"
                @goToUser="goToUser"
                @goToTarget="goToTarget"
                @removeOrder="removeOrder"
                @addOrder="addOrder"
              ></Table>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-12 col-md-10 offset-md-1 text-center " >
          <div class="alert alert-primary mx-5 my-2 px-2 py-4 ">
            <h6>
              <i class="fas fa-exclamation-triangle mr-2"></i>
              No orders bookers to show
            </h6>
          </div>
        </div>
      </div>
    </div>
    <modal
          name="addOrderToBooker"
          class="modal-preview p-1"
          :resizable="true"
          height="auto"
          width="40%"
          :max-width="500"
          style="z-index: 10"
          :click-to-close="false"
          :esc-to-close="false"
        >
        <LoadingSpinner v-if="loadingModal"></LoadingSpinner>
        <div v-else>
          <div class="p-4 my-1 text-center text-secondary" v-if="bookerSelected">

        <div class="row">
          <div class="col-12">
            <h5>Add order to Booker: {{ this.bookerSelected.name }}</h5>
          </div>
          <div class="col-12 mt-2" v-if="!loadingTargets">
            <label class="font-weight-bold d-block text-left mb-1">Primary orders</label>
            <treeselect
              v-model="primaryTargetsSelected"
              class="mb-2"
              :multiple="true"
              :required="false"
              :maxHeight="200"
              :show-count="true"
              :searchable="true"
              :append-to-body="true"
              :options="primaryTargets"
              :loading="loadingTargets"
            >
            </treeselect>
          </div>
          <div class="col-12" v-if="!loadingTargets">
            <label class="font-weight-bold d-block text-left mb-1">Secondary orders</label>
            <treeselect
              v-model="secondaryTargetsSelected"
              class="mb-2"
              :multiple="true"
              :required="false"
              :maxHeight="200"
              :show-count="true"
              :searchable="true"
              :append-to-body="true"
              :options="secondaryTargets"
              :loading="loadingTargets"
            >
            </treeselect>
          </div>
          <div class="col-12" v-if="!loadingTargets">
            <label class="font-weight-bold d-block text-left mb-1">Tertiary orders</label>
            <treeselect
              v-model="tertiaryTargetsSelected"
              class="mb-2"
              :multiple="true"
              :required="false"
              :maxHeight="200"
              :show-count="true"
              :searchable="true"
              :append-to-body="true"
              :options="tertiaryTargets"
              :loading="loadingTargets"
            >
            </treeselect>
          </div> 
          <div v-else class="col-12 text-center"> 
            <span class="my-2 spinner-border spinner-border-sm" ></span>    
          </div>               
          <div class="col-12 mt-3">
            <button 
              @click="saveNewOrderToBooker" 
              class="btn btn-primary mr-4"
              :disabled="!canSaveTargetsByPriority">
              Add Target
            </button>
            <button @click="closeModal('addOrderToBooker')" class="btn btn-secondary">
              {{ $t("lang.button.close") }}
            </button>
          </div>
        </div>
          </div>
      </div>
  </modal>
  </div>
  

</template>

<script>
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { bookersService } from "@/_services";
import Treeselect from "@riophae/vue-treeselect";
import Tabs from "@/components/Common/Tabs.vue";

export default {
  components: {
    Table,
    LoadingSpinner,
    Treeselect,
    Tabs,
  },
  data() {
    return {
      tabs: {
        1: {
          id: 1,
          name: 'Less than 150 tasks',
        },
        2: {
          id: 2,
          name: "More than 150 tasks",
        },        
      },
      tabSelected: 1,
      orderDirection: 'desc',
      orderBy: 'total_cold_tasks',
      loadingModal: false,
      keyTable: 1,
      loadingTargets: false,
      primaryTargetsSelected: [],
      secondaryTargetsSelected: [],
      tertiaryTargetsSelected: [],
      targets: [],
      bookerSelected: null,
      loading: false,
      orders: [],
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
          {
            value: "avatar",
            type: "image",
            width: "25px",
          },
        ],
        [
          {
            value_label: "name",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "goToUser",
          },
        ],
        [
          {
            value: "user_bdr_status_id",
            value_label: "bdr_status",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "1",
                label: "Screening",
                bgColor: "gray",
                textColor: "#FFFFFF",
              },
              {
                id: "2",
                label: "Onboarding",
                bgColor: "orange",
                textColor: "#FFFFFF",
              },
              {
                id: "3",
                label: "Validated",
                bgColor: "#008080",
                textColor: "#FFFFFF",
              },
              {
                id: "4",
                label: "Level 1",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "5",
                label: "Booker Level 2",
                bgColor: "#FF8C00",
                textColor: "#FFFFFF",
              },
              {
                id: "6",
                label: "Booker Manager",
                bgColor: "#4B0082",
                textColor: "#FFFFFF",
              },
              {
                id: "7",
                label: "Stopped",
                bgColor: "#B22222",
                textColor: "#FFFFFF",
              },
              {
                id: "8",
                label: "Rejected",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "9",
                label: "Test",
                bgColor: "black",
                textColor: "#FFFFFF",
              },
              {
                id: "10",
                label: "Booker France",
                bgColor: "blue",
                textColor: "#FFFFFF",
              },
              {
                id: "11",
                label: "Booker Hivy",
                bgColor: "yellow",
                textColor: "black",
              },
              {
                id: "14",
                label: "Props. Closing",
                bgColor: "#C6F505",
                textColor: "black",
              },
              {
                id: "15",
                label: "Booker Level 3",
                bgColor: "#279CF5",
                textColor: "#FFFFFF",
              },
              {
                id: "16",
                label: "Booker Level 4",
                bgColor: "#F5AD27",
                textColor: "#FFFFFF",
              },
              {
                id: "empty",
                label: "",
                bgColor: "white",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            value: "cold_meeting_rate",
            format: "percentage",
          },
        ],
        [
          {
            value: "cold_meetings",
          },
        ],        
        [
          {
            value: "days_seniority",
          },
        ],
        [
          {
            value: "targets_booker",
            type: "targetsList",
          },
        ],
        [
          {
            value: "total_cold_tasks",
            type:"qty",
            min: "100",
            class_danger: 'text-danger',
          },
        ],
      ],
      headers: [
        {
          label: "Photo",
          percentage: "1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Booker",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Level",
          percentage: "5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Cold meeting rate",
          percentage: "5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Cold meetings",
          percentage: "5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Seniority",
          percentage: "5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.orders.orders"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Total cold tasks",
          percentage: "5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  computed: {
    isAllSelected() {
      const table = this.$refs.bookerTable;
      if (!table) return false;
      return table.isAllTargetsInTableSelected();
    },
    canSaveTargetsByPriority() {
      return Array.isArray(this.primaryTargetsSelected) && this.primaryTargetsSelected.length > 0;
    },
    primaryTargets() {
      return this.filterTargetsByOtherLevels(this.primaryTargetsSelected);
    },
    secondaryTargets() {
      return this.filterTargetsByOtherLevels(this.secondaryTargetsSelected);
    },
    tertiaryTargets() {
      return this.filterTargetsByOtherLevels(this.tertiaryTargetsSelected);
    },
  },
  methods: {
    toggleSelectAll() {
      const table = this.$refs.bookerTable;
      if (!table) return;
      table.toggleAllTargetsInTable();
      this.keyTable = this.keyTable; // force reactivity on computed
      this.$forceUpdate();
    },
    normalizeTargetId(targetId) {
      return String(targetId || "").trim();
    },
    filterTargetsByOtherLevels(keepSelected = []) {
      const selectedIds = new Set([
        ...(this.primaryTargetsSelected || []),
        ...(this.secondaryTargetsSelected || []),
        ...(this.tertiaryTargetsSelected || []),
      ].map((id) => this.normalizeTargetId(id)));

      (keepSelected || []).forEach((id) => selectedIds.delete(this.normalizeTargetId(id)));

      return this.targets.filter((target) => !selectedIds.has(this.normalizeTargetId(target.id)));
    },
    getEffectivePriority(priority) {
      const parsed = Number(priority);
      if ([1, 2, 3].includes(parsed)) return parsed;
      return 1;
    },
    getPriorityBadge(priority) {
      const effectivePriority = this.getEffectivePriority(priority);
      if (effectivePriority === 1) return "[P]";
      if (effectivePriority === 2) return "[S]";
      return "[T]";
    },
    parseBookerTargetsPriorityRaw(rawTargetsPriority) {
      if (!rawTargetsPriority) return [];

      if (Array.isArray(rawTargetsPriority)) {
        return rawTargetsPriority;
      }

      if (typeof rawTargetsPriority === "object") {
        return [rawTargetsPriority];
      }

      if (typeof rawTargetsPriority !== "string") return [];

      const trimmed = rawTargetsPriority.trim();
      if (!trimmed) return [];

      if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
        try {
          const parsed = JSON.parse(trimmed);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }

      return trimmed
        .split(";;")
        .map((entry) => entry.trim())
        .filter(Boolean)
        .map((entry) => {
          const [id, clientName = "", priorityValue = ""] = entry.split("|");
          const normalizedPriority = String(priorityValue).trim();
          return {
            target_id: id ? String(id).trim() : "",
            client_name: String(clientName).trim(),
            priority: normalizedPriority === "" ? null : Number(normalizedPriority),
          };
        })
        .filter((item) => item.target_id !== "");
    },
    parseBookerTargetsRaw(rawTargets) {
      if (!rawTargets) return [];

      if (Array.isArray(rawTargets)) {
        return rawTargets;
      }

      if (typeof rawTargets === "string") {
        const trimmed = rawTargets.trim();

        if (!trimmed) return [];

        if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
          try {
            const parsed = JSON.parse(trimmed);
            return Array.isArray(parsed) ? parsed : [];
          } catch (e) {
            return [];
          }
        }

        return trimmed.split(",").map((targetStr) => {
          const [id, ...nameParts] = targetStr.split("-");
          return {
            target_id: id ? id.trim() : "",
            client_name: nameParts.join("-").trim(),
            priority: null,
          };
        });
      }

      return [];
    },
    getOrdersFiltered(){  
      if(this.orders.length == 0) return []

      if(this.tabSelected == 1){
        return this.orders.filter(el => el.total_cold_tasks <= 150)
      } else {
        return this.orders.filter(el => el.total_cold_tasks > 150)
      }
    },
    changeTab(id) {
      this.tabSelected = id;
    },
    updateOrder(){       

      //Si es numerico
      if(this.orderDirection === 'asc'){
        this.orders.sort((a, b) => a[this.orderBy] - b[this.orderBy]);
      }
      else{
        this.orders.sort((a, b) => b[this.orderBy] - a[this.orderBy]);
      }    

    },
    closeModal(name) {
      this.$modal.hide(name);
      this.bookerSelected = null
      this.targets = []
      this.primaryTargetsSelected = []
      this.secondaryTargetsSelected = []
      this.tertiaryTargetsSelected = []
    },
    saveNewOrderToBooker(){
      this.loadingModal = true

      const primary = (this.primaryTargetsSelected || []).map((id) => this.normalizeTargetId(id)).filter(Boolean)
      const secondary = (this.secondaryTargetsSelected || []).map((id) => this.normalizeTargetId(id)).filter(Boolean)
      const tertiary = (this.tertiaryTargetsSelected || []).map((id) => this.normalizeTargetId(id)).filter(Boolean)

      const hasOverlap =
        primary.some((id) => secondary.includes(id) || tertiary.includes(id)) ||
        secondary.some((id) => tertiary.includes(id))

      if (hasOverlap) {
        this.loadingModal = false
        this.$swal({
          icon: "error",
          title: "Invalid selection",
          text: "One order cannot belong to more than one priority level for the same booker.",
        })
        return
      }

      const targetIds = [...new Set([...primary, ...secondary, ...tertiary])]

      const payload = {
        primary,
        secondary,
        tertiary,
        targetIds,
      }

      bookersService.assignTargetOfBooker(this.bookerSelected.id, payload)
      .then((response) => {
        if (response.status == 200) {
          this.closeModal('addOrderToBooker')          
          this.getData();
        }
      });
    },
    addOrder(row){
      this.$modal.show("addOrderToBooker")
      this.loadingModal = false
      this.primaryTargetsSelected = []
      this.secondaryTargetsSelected = []
      this.tertiaryTargetsSelected = []

      this.bookerSelected = row

      const assignedById = {}
      ;(row.targets_booker || []).forEach((order) => {
        const normalizedId = this.normalizeTargetId(order.target_id)
        if (!normalizedId) return

        const priority = this.getEffectivePriority(order.effective_priority || order.priority)
        assignedById[normalizedId] = {
          target_id: normalizedId,
          priority,
          label: order.label,
        }

        if (priority === 1) this.primaryTargetsSelected.push(normalizedId)
        else if (priority === 2) this.secondaryTargetsSelected.push(normalizedId)
        else this.tertiaryTargetsSelected.push(normalizedId)
      })

      this.loadingTargets = true
      bookersService.getTargetsToAssing(row.id)
      .then((response) => {
        if (response.status == 200) {
          const availableTargets = response.result.map( el => {
            const normalizedId = this.normalizeTargetId(el.target_id)
            return {
              ...el,
              id: normalizedId,
              label: el.client_id + " - " + el.client_name + " - " + el.target_id + " - " + el.name + " - " + el.conversion_rate,
            }
          })

          const availableTargetsById = {}
          availableTargets.forEach((target) => {
            availableTargetsById[this.normalizeTargetId(target.id)] = target
          })

          Object.keys(assignedById).forEach((targetId) => {
            if (availableTargetsById[targetId]) return

            const assigned = assignedById[targetId]
            const cleanLabel = String(assigned.label || "")
              .replace(/^\[[PST]\]\s*/, "")
              .replace(/\s-\s\d+$/, "")

            availableTargets.push({
              id: targetId,
              target_id: targetId,
              label: cleanLabel || targetId,
            })
          })

          this.targets = availableTargets

          this.loadingTargets = false
        }
      });      
    },
    removeOrder(item){  
      this.orders.find(el => el.id == item.bookerId).targets_booker.find( e => e.target_id == item.targetId ).hide = true 
      this.orders.find(el => el.id == item.bookerId).targets_booker.find( e => e.target_id == item.targetId ).loading = true 
      this.keyTable++
      
      bookersService.unassignTargetOfBooker(item.bookerId, item.targetId)
      .then((response) => {
        if (response.status == 200) {
          this.orders.find(el => el.id == item.bookerId).targets_booker.find( e => e.target_id == item.targetId ).loading = false
          this.keyTable++
        }
      });
    },
    getData() {
      this.loading = true;
      bookersService.getOrderDistribution().then((response) => {
        if (response.status == 200) {
          const bookers = response.result.bookers;
          bookers.forEach((element) =>{
            if(element.has_avatar == 1){
              let base64 = '';
              base64 = btoa(`usr-${element.id}`);
              element.avatar = process.env.VUE_APP_ROOT_API + '/redirect/image/' + base64;
            }else{
              element.avatar = require('@/assets/images/emptyperson.png');
            }
          })
          const targets = response.result.targets;
          this.orders = this.parseBookerTargets(bookers, targets);
          this.updateOrder()
        }
        this.loading = false;
      });
    },

    parseBookerTargets(bookers, allTargets) {
      return bookers.map((booker) => {
        const rawTargets = booker.targets;
        const rawTargetsPriority = booker.targets_priority;
        const parsedTargetsByPriority = this.parseBookerTargetsPriorityRaw(rawTargetsPriority);
        const parsedTargets = parsedTargetsByPriority.length
          ? parsedTargetsByPriority
          : this.parseBookerTargetsRaw(rawTargets);
        const targets_booker = []; //obtengo la variable con (CLIENT_NAME - TARGET_ID - pending cold tasks)
        const booker_target_id = []; // Obtengo los target_id por separado para evaluarlos en el table.vue
        let total_cold_tasks = 0; // suma de las tareas pendiente que hay sobre todas las orders sobre que esta el booker

        if (parsedTargets.length) {
          parsedTargets.forEach((targetItem) => {
            const target_id = String(targetItem.target_id || "").trim();
            const client_name = (targetItem.client_name || "").trim();
            const priority = targetItem.priority;
            const effectivePriority = this.getEffectivePriority(priority);

            const matched = allTargets.find((t) => String(t.target_id) === target_id);

            if (matched) {
              const tasks = parseFloat(matched.total_tasks || 0);
              const bookers = parseFloat(matched.total_bookers || 1); // evitar división por cero
              const tasks_per_booker = tasks / (bookers || 1); // fallback defensivo
              const should_call = matched.should_call_target;
              total_cold_tasks += tasks_per_booker;

              targets_booker.push({ //convierto a objeto para evaluar en table.vue relacionando target_id con cada target que tenga asignado el booker
                label: `${this.getPriorityBadge(effectivePriority)} ${client_name} - ${target_id} - ${matched.total_tasks}`,
                target_id,
                total_tasks: matched.total_tasks,
                finished: matched.finished,
                should_call: should_call,
                priority,
                effective_priority: effectivePriority,
              });
            } else {
              targets_booker.push({
                label: `${this.getPriorityBadge(effectivePriority)} ${client_name} - ${target_id} - 0`,
                target_id,
                total_tasks: 0,
                finished: 1,
                priority,
                effective_priority: effectivePriority,
              });
            }

            if (booker_target_id)
              booker_target_id.push({ target_id, client_name });
          });
        }

        return { //adjunto al array que tiene info de la api, la columna order (targets_booker), columna total cold task (total_cold_tasks), y los ids de los targets que tenga cada booker
          ...booker,
          targets_booker,
          total_cold_tasks: Math.round(total_cold_tasks),
          booker_target_id,
        };
      });
    },

    goToUser(user_id) {
      window.open("/users/" + user_id, "_blank");
    },

    goToTarget(target_id) {
      let url = "/orders/" + target_id;
      window.open(url, "_blank");
    },
  },
};
</script>
